import { Provider } from './Provider.js';

class BeamerProvider extends Provider {
  track(_properties) {
    this.logger.error('Beamer track - Method not implemented');
  }
  setUserId(_userId) {
    this.logger.error('Beamer set user id - Method not implemented');
  }
  setUserProperties(_ref) {
    let {
      properties
    } = _ref;
    if (typeof Beamer !== 'undefined' && window.beamer_config) {
      const updatedConfig = Object.fromEntries(properties.map(_ref2 => {
        let {
          key,
          value
        } = _ref2;
        return [key, value];
      }));
      Beamer.update(updatedConfig);
    }
  }
  scriptIsLoaded() {
    if (typeof document !== 'undefined') {
      const htmlScripts = Array.from(document.getElementsByTagName('script'));
      return !!htmlScripts.find(script => script.src === 'https://app.getbeamer.com/js/beamer-embed.js');
    }
    return false;
  }

  /**
   * Initializes the API
   * @param key Beamer API key
   * @param configuration Configuration object https://www.getbeamer.com/docs/#parameters
   */
  init(key, configuration) {
    if (!this.scriptIsLoaded() && typeof document !== 'undefined') {
      const fullConfig = {
        ...configuration,
        product_id: key
      };
      window.beamer_config = fullConfig;
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://app.getbeamer.com/js/beamer-embed.js';
      script.defer = true;
      document.getElementsByTagName('body')[0].appendChild(script);
      this.logger.log(`Beamer script appended to <body> with Key: ${key}`);
    }
  }
}

export { BeamerProvider };
//# sourceMappingURL=BeamerProvider.js.map
